export default "__VITE_ASSET__D5g2Ovmc__"